import { jsx as _jsx } from "react/jsx-runtime";
import { Slider } from '@mui/material';
const RangeSlider = ({ value, handleChangeRange, valueText, ariaLabel, marks = false, min, max }) => {
    return (_jsx(Slider, { getAriaLabel: ariaLabel, value: value, onChange: handleChangeRange, valueLabelDisplay: 'auto', disableSwap: true, getAriaValueText: valueText, marks: marks, track: 'inverted', step: 1, min: min, max: max }));
};
export default RangeSlider;
